import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { memo } from 'react';
import { Box } from '@mui/material';
import { createSelector } from '@reduxjs/toolkit';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import 'console/react-elements/important-event.sass';
import { LegacyDevice } from 'console/device/device';
import { Capability } from 'console/device/device-capability';
import { ImportantEvent } from '../event';
import { EmptyPlaceholder, UnreadSeparator } from '../tips';
import { selectDevicesFields } from 'entities/device/lib';
const deviceGPSSelector = createSelector(selectDevicesFields(['id', 'capabilities']), (devs) => Object.fromEntries(devs.map((dev) => [
    dev.id,
    LegacyDevice.has_capability(dev?.capabilities, Capability.has_gps),
])));
export const ImportantEventsList = memo(function ImportantEventsList(props) {
    const { important_events, devid2name, onClose } = props;
    const hasGps = useAppSelector(deviceGPSSelector);
    return (_jsxs(Box, { display: "flex", flexDirection: "column", children: [important_events.events.length === 0 && _jsx(EmptyPlaceholder, {}), important_events.events
                .slice(0, important_events.unread)
                .map((event, i) => {
                const { device_id } = event;
                const dev_id = device_id ?? -1;
                return (_jsx(ImportantEvent, { close: onClose, event: event, unread: true, device_name: devid2name[dev_id], hasGps: !!hasGps[dev_id] }, important_events.events.length - i));
            }), important_events.events.length > important_events.unread && (_jsx(UnreadSeparator, {})), important_events.events.slice(important_events.unread).map((event, i) => {
                const { device_id } = event;
                const dev_id = device_id ?? -1;
                return (_jsx(ImportantEvent, { close: onClose, event: event, unread: false, device_name: devid2name[dev_id], hasGps: !!hasGps[dev_id] }, important_events.events.length - i));
            })] }));
});
